import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </M>
  );
};

export const SectionHead = ({ index, label, title, text, dark = false, className = "" }) => (
  <div className={`max-w-3xl ${className}`}>
    <Reveal>
      <p className={`eyebrow flex items-center gap-3 ${dark ? "text-cyan-300" : "text-blue-700"}`}>
        <span className={dark ? "text-slate-400" : "text-slate-500"}>{index}</span>
        <span className="grad-line inline-block h-px w-8" />
        {label}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`mt-5 text-3xl font-extrabold leading-[1.12] tracking-[-0.03em] sm:text-4xl lg:text-[3.25rem] ${dark ? "text-white" : "text-slate-950"}`}>{title}</h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p className={`mt-5 max-w-2xl text-base leading-relaxed md:text-lg ${dark ? "text-slate-300" : "text-slate-600"}`}>{text}</p>
      </Reveal>
    )}
  </div>
);
